import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const getDefaultCulture = () => {
  switch (new URLSearchParams(window.location.search).get('lng')?.toLowerCase()) {
    case 'en':
      return 'en-US';
    default:
      return 'cs-CZ';
  }
};

export interface MainState {
  culture: string;
}

const initialState: MainState = {
  culture: getDefaultCulture(),
};

const mainSlice = createSlice({
  name: 'main',
  initialState,
  reducers: {
    setCulture: (state, action: PayloadAction<string>) => {
      state.culture = action.payload;
    },
  },
});

export const { setCulture } = mainSlice.actions;

export default mainSlice;
